import { render, staticRenderFns } from "./scoreManage.vue?vue&type=template&id=df8e9104&scoped=true&"
import script from "./scoreManage.vue?vue&type=script&lang=js&"
export * from "./scoreManage.vue?vue&type=script&lang=js&"
import style0 from "./scoreManage.vue?vue&type=style&index=0&id=df8e9104&lang=scss&scoped=true&"
import style1 from "./scoreManage.vue?vue&type=style&index=1&id=df8e9104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8e9104",
  null
  
)

export default component.exports